// Read-only staging client. Never store or hardcode tokens here.
export const STAGING_API_ORIGIN = 'https://staging-api.beautyspotapp.co.uk';
export const DASHBOARD_ROUTES = Object.freeze({
  counts: '/api/dashboards/admin/count',
  overview: '/api/dashboards/admin/overview',
  providers: '/api/dashboards/admin/providers',
  signups: '/api/dashboards/admin/signUp/graph',
  revenue: '/api/dashboards/admin/revenue/graph',
  retention: '/api/dashboards/admin/retention/graph',
  commission: '/api/dashboards/admin/commission/graph',
  categories: '/api/dashboards/admin/category/graph',
});

// Explicit opt-in required; defaults to mock/preview. Do not send credentials until
// server-side administrator authorization and CORS have been verified.
export async function fetchStagingDashboard(routeKey, { token, query = {}, enabled = false } = {}) {
  if (!enabled) throw new Error('Staging API access is disabled until security review.');
  if (!token) throw new Error('An authorized staging admin session is required.');
  if (!(routeKey in DASHBOARD_ROUTES)) throw new Error('Unknown read-only dashboard route.');
  const url = new URL(DASHBOARD_ROUTES[routeKey], STAGING_API_ORIGIN);
  Object.entries(query).forEach(([key, value]) => { if (value != null) url.searchParams.set(key, String(value)); });
  const response = await fetch(url.toString(), { method: 'GET', headers: { 'x-access-token': token, Accept: 'application/json' }, cache: 'no-store' });
  if (!response.ok) throw new Error(`Staging dashboard request failed (${response.status})`);
  return response.json();
}
